<script setup lang="ts">
import { RouterView } from 'vue-router'
import AppHeader from '@/components/app/AppHeader.vue'
import { OptionsSnackbar } from '@haskoning/vue-component-library'
</script>

<template>
  <v-app>
    <AppHeader />
    <v-main>
      <RouterView />
    </v-main>
    <OptionsSnackbar
      style="z-index: 3000"
      :excluded-http-methods="['GET', 'OPTIONS']"
    ></OptionsSnackbar>
  </v-app>
</template>
<style lang="scss">
// the main file that imports everything related with styles
@use '/src/scss/settings.scss';
</style>
